// app/javascript/controllers/stock_chart_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["rangeSelector"]

  updateRange(event) {
    event.preventDefault()
    
    // Update active button state
    this.rangeSelector.querySelectorAll('.range-button').forEach(btn => {
      btn.classList.remove('active')
    })
    event.target.classList.add('active')
    
    // The form submission will be handled by Turbo automatically
    // due to the turbo_frame attribute
  }
}